import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { NgbAlertModule, NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HireSearchService } from '../../services/hire-search.service';
import { CandidateNoteComponent } from 'src/app/candidate/candidate-note/candidate-note.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';

@Component({
  selector: 'app-hire-notes',
  imports: [NgbCollapse, CommonModule, NgbAlertModule],
  templateUrl: './hire-notes.component.html',
  styleUrl: './hire-notes.component.scss',
})
export class HireNotesComponent {
  @Input() candidateDetails: any;
isCollapsed:boolean=false
 isCollapsed2:boolean=true
 isCollapsed3:boolean=false
 successMessage: string = ''; // Property to hold the success message
 errorMessage: string = ''; // Property to hold the error message

 currentURL: string;
 notes: any[] = [];
 @Input() calledFrom: string;
   isLoggedinUserIsAdmin : boolean =false;
   note: any;
   /**
    * Notifies the parent (side panel -> slider) that a note was added, edited, or
    * deleted, so the Activity tab can refetch and show the new entry in real time.
    */
   @Output() notesUpdated = new EventEmitter<any>();


 constructor(private hireSearchService: HireSearchService, private modalService: NgbModal, private router: Router, private localstorageservice: LocalStorageService, private candidateService: CandidateService) {}

 ngOnInit() {
  this.currentURL = this.router.url;
      this.isLoggedinUserIsAdmin = this.localstorageservice.getItem('role') =='team admin' ? true :false

  if(this.calledFrom == 'pipeline-list' || this.calledFrom == 'my-candidates') {
    this.getNotes();

  }

 }

 getNotes() {
  const payload = {
    candidatenumber: this.candidateDetails?.basicdetails?.candidatenumber,
    start: 0
  }

  this.hireSearchService.getHireNotes(payload).subscribe(
    (response) => {
      if (response.status === 'success') {
        this.notes = response.message.getnotes;
        // Handle the response
      }

    },
    (error) => {
      // Handle the error
    }
  );
 }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['candidateDetails'] && !changes['candidateDetails'].firstChange) {
      const previousCandidateNumber = changes['candidateDetails'].previousValue?.basicdetails?.candidatenumber;
      const currentCandidateNumber = changes['candidateDetails'].currentValue?.basicdetails?.candidatenumber;
      if ((this.calledFrom == 'pipeline-list' || this.calledFrom == 'my-candidates') && previousCandidateNumber !== currentCandidateNumber) {
        this.getNotes();
      }
    }
  }

   addNotes() {
     const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
     modalRef.componentInstance.noteforCandidate = this.candidateDetails ? this.candidateDetails.basicdetails  : null
     modalRef.componentInstance.passEntry.subscribe((x) => {
       if (x == 'noteAdded') {
         this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        this.getNotes();
        this.notesUpdated.emit(this.candidateDetails);
       } else if (x == 'error') {
         this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
       }
     })
   }

     toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }

    editnotes(note) {
    this.note = note.note;
    const modalRef = this.modalService.open(CandidateNoteComponent, { size: 'xs' as 'lg', centered: true });
    modalRef.componentInstance.editnoteid = note.candidatenoteid;
    modalRef.componentInstance.noteforCandidate = this.candidateDetails.basicdetails

    modalRef.componentInstance.passEntry.subscribe((x) => {
      if (x == 'noteAdded') {
        this.toastmessage('Notes Added for Selected Candidate Succesfully', 'success')
        this.getNotes();
        this.notesUpdated.emit(this.candidateDetails);
      } else if (x == 'error') {
        this.toastmessage('Something went Wrong, Please try again in a minute', 'error')
      } else if( x == 'updated'){
        this.toastmessage('Notes edited for Selected Candidate Succesfully', 'success')
        this.getNotes();
        this.notesUpdated.emit(this.candidateDetails);
      }
    })
  }

    deletenotesmodal(noteAdded) {
    let payload = {
      candidatenumber: this.candidateDetails.basicdetails.candidatenumber,
      noteid: noteAdded.candidatenoteid
    }
    this.candidateService.archivecandidatesnotes(payload).subscribe((res:any)=>{
      if(res.status == "success") {
        this.modalService.dismissAll()
        this.getNotes();
        this.notesUpdated.emit(this.candidateDetails);

        this.toastmessage('Notes deleted successfully', 'success')
      } else {
        this.toastmessage('Something went wrong', 'success')
      }

    })

  }


}
